var _line, _line2, _path, _path2, _mask, _path3, _path4, _ellipse, _g, _ellipse2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 20,
    viewBox: "0 0 82 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.52513e-10,
    y1: 12.6803,
    x2: 82,
    y2: 12.6803,
    stroke: "#2E5CF6",
    strokeWidth: 1.30645,
    strokeLinejoin: "round",
    strokeDasharray: "5.23 5.23"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 12.6803,
    x2: 82,
    y2: 12.6803,
    stroke: "#2E5CF6",
    strokeWidth: 1.30645,
    strokeLinejoin: "round",
    strokeDasharray: "5.23 5.23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1855 11.9999C60.1855 18.2715 55.1437 23.3466 48.9355 23.3466C42.7272 23.3466 37.6855 18.2715 37.6855 11.9999C37.6855 5.72831 42.7272 0.653226 48.9355 0.653226C55.1437 0.653226 60.1855 5.72831 60.1855 11.9999Z",
    fill: "white",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3144 11.9999C44.3144 18.2715 39.2726 23.3466 33.0644 23.3466C26.8561 23.3466 21.8144 18.2715 21.8144 11.9999C21.8144 5.72831 26.8561 0.653226 33.0644 0.653226C39.2726 0.653226 44.3144 5.72831 44.3144 11.9999Z",
    fill: "white",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1162_8524",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 20.9443C43.4352 18.7471 44.9677 15.554 44.9677 12C44.9677 8.44602 43.4352 5.25291 41 3.05564C38.5648 5.25291 37.0322 8.44602 37.0322 12C37.0322 15.554 38.5648 18.7471 41 20.9443Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 20.9443C43.4352 18.7471 44.9677 15.554 44.9677 12C44.9677 8.44602 43.4352 5.25291 41 3.05564C38.5648 5.25291 37.0322 8.44602 37.0322 12C37.0322 15.554 38.5648 18.7471 41 20.9443Z",
    fill: "#2E5CF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20.9443L40.1248 21.9143L41 22.704L41.8752 21.9143L41 20.9443ZM41 3.05564L41.8752 2.08567L41 1.29599L40.1248 2.08567L41 3.05564ZM37.0322 12L35.7258 12L37.0322 12ZM43.6613 12C43.6613 15.1707 42.2956 18.0157 40.1248 19.9744L41.8752 21.9143C44.5747 19.4785 46.2742 15.9372 46.2742 12L43.6613 12ZM40.1248 4.02562C42.2956 5.98433 43.6613 8.82928 43.6613 12L46.2742 12C46.2742 8.06276 44.5747 4.52148 41.8752 2.08567L40.1248 4.02562ZM38.3387 12C38.3387 8.82929 39.7043 5.98433 41.8752 4.02562L40.1248 2.08567C37.4252 4.52148 35.7258 8.06276 35.7258 12L38.3387 12ZM41.8752 19.9744C39.7043 18.0157 38.3387 15.1707 38.3387 12L35.7258 12C35.7258 15.9372 37.4252 19.4785 40.1248 21.9143L41.8752 19.9744Z",
    fill: "#2E5CF6",
    mask: "url(#path-5-inside-1_1162_8524)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1162_8524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 24,
    height: 24
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0644,
    cy: 11.9999,
    rx: 11.9032,
    ry: 11.9999,
    fill: "#DDDDDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1162_8524)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704241 0.709961 -0.951084 -0.308931 39.5664 17.4443)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704241 0.709961 -0.951084 -0.308931 39.5664 10.8892)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704241 0.709961 -0.951084 -0.308931 39.5664 4.3335)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 29.5697,
    y2: -0.653226,
    transform: "matrix(-0.704241 0.709961 -0.951084 -0.308931 40.7676 -3.32617)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 29.5697,
    y2: -0.653226,
    transform: "matrix(-0.704241 0.709961 -0.951084 -0.308931 40.7676 -9.65332)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1162_8524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 0,
    width: 24,
    height: 24
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9356,
    cy: 11.9999,
    rx: 11.9999,
    ry: 11.9032,
    transform: "rotate(90 48.9356 11.9999)",
    fill: "#DDDDDD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1162_8524)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704242 -0.70996 0.304437 -0.952532 51.4697 27.1509)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704241 -0.709961 0.304437 -0.952532 55.3286 24.1245)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 28.0134,
    y2: -0.653226,
    transform: "matrix(-0.704242 -0.70996 0.304437 -0.952532 59.1855 21.458)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 29.5697,
    y2: -0.653226,
    transform: "matrix(-0.704241 -0.709961 0.304437 -0.952532 64.1372 20)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.653226,
    x2: 29.5697,
    y2: -0.653226,
    transform: "matrix(-0.704241 -0.709961 0.304437 -0.952532 65.124 14.6665)",
    stroke: "#2E5CF6",
    strokeWidth: 1.30645
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.a8f59c6c.svg";
export { ForwardRef as ReactComponent };